import Icon from '../components/Icon.vue'

Icon.register({
  'id-badge': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M336 0c26.5 0 48 21.5 48 48v416c0 26.5-21.5 48-48 48h-288c-26.5 0-48-21.5-48-48v-416c0-26.5 21.5-48 48-48h288zM144 32c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96zM192 160c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zM304 396.8v-19.2c0-31.8-30.1-57.6-67.2-57.6h-5c-12.2 5.1-25.7 8-39.8 8s-27.5-2.9-39.8-8h-5c-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2h179.2c12.4 0 22.4-8.6 22.4-19.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/id-badge.js
// module id = 1481
// module chunks = 0